const SECTIONS = [
  {
    id: "operator",
    title: "Website Operator",
    blocks: [
      { t: "ul", items: ["Website Name: BurmeseHub.com", "Country: United States of America", "Authorized Representative: Si Thu Kyaw, Owner"] },
      { t: "link", label: "Website:", x: "https://www.burmesehub.com", href: "/", testid: "impressum-website" },
      { t: "link", label: "Email:", x: "admin@burmesehub.com", href: "mailto:admin@burmesehub.com", testid: "impressum-email" },
    ],
  },
  {
    id: "about",
    title: "About BurmeseHub",
    blocks: [
      { t: "p", x: "BurmeseHub is an independent online business and community directory dedicated to connecting Burmese-owned businesses, professionals, organizations, and communities across the United States." },
      { t: "p", x: "Our platform helps visitors discover restaurants, grocery stores, professional services, real estate services, employment opportunities, community events, and local resources." },
      { t: "p", x: "Our mission is to support business visibility, encourage meaningful connections, and strengthen community engagement." },
      { t: "motto", x: "BurmeseHub.com — Find. Connect. Belong." },
    ],
  },
  {
    id: "content-responsibility",
    title: "Responsibility for Website Content",
    blocks: [
      { t: "p", x: "BurmeseHub makes reasonable efforts to maintain accurate, relevant, and useful information." },
      { t: "p", x: "However, business listings, advertisements, and other third-party submissions may contain information provided by independent individuals or businesses." },
      { t: "p", x: "We do not guarantee that all published information is complete, accurate, or current." },
      { t: "p", x: "Content may be corrected, updated, or removed when appropriate." },
    ],
  },
  {
    id: "listing-disclaimer",
    title: "Business Listing Disclaimer",
    blocks: [
      { t: "p", x: "Businesses featured on BurmeseHub are independently owned or operated unless expressly stated otherwise." },
      { t: "p", x: "Inclusion in the directory does not automatically constitute verification, certification, endorsement, or partnership with BurmeseHub." },
      { t: "p", x: "Visitors should independently confirm business details, qualifications, pricing, and availability before entering into transactions." },
    ],
  },
  {
    id: "copyright",
    title: "Copyright and Intellectual Property",
    blocks: [
      { t: "p", x: "Unless otherwise indicated, BurmeseHub retains the rights to its original website content, branding, graphics, and design." },
      { t: "p", x: "Logos, trademarks, photographs, and other content belonging to listed businesses remain the property of their respective owners or authorized rights holders." },
      { t: "p", x: "Unauthorized reproduction or commercial distribution of protected content is prohibited except as permitted by applicable law." },
    ],
  },
  {
    id: "external-links",
    title: "External Links",
    blocks: [
      { t: "p", x: "BurmeseHub may provide links to independently operated websites, social media pages, and third-party services." },
      { t: "p", x: "We do not control the content or privacy practices of these external platforms and are not responsible for their independent operations, except where applicable law provides otherwise." },
    ],
  },
  {
    id: "reporting",
    title: "Reporting Concerns",
    blocks: [
      { t: "p", x: "If you believe a listing contains inaccurate, unauthorized, misleading, or infringing information, please contact us." },
      { t: "p", x: "Include the relevant listing URL, a description of the concern, and your contact information so we can review the request." },
    ],
  },
  {
    id: "privacy-terms",
    title: "Privacy and Terms",
    blocks: [
      { t: "p", x: "For additional information about our website policies, please review:" },
      { t: "link", label: "Privacy Policy", x: "https://www.burmesehub.com/privacy-policy", href: "/privacy-policy", testid: "impressum-privacy-link" },
      { t: "link", label: "Terms of Service", x: "https://www.burmesehub.com/terms-of-service", href: "/terms-of-service", testid: "impressum-terms-link" },
    ],
  },
  {
    id: "contact",
    title: "Contact Information",
    blocks: [
      { t: "p", x: "For general inquiries, business listing requests, privacy concerns, or legal notices:" },
      { t: "p", x: "BurmeseHub.com" },
      { t: "link", label: "Website:", x: "https://www.burmesehub.com", href: "/", testid: "impressum-contact-website" },
      { t: "link", label: "Email:", x: "admin@burmesehub.com", href: "mailto:admin@burmesehub.com", testid: "impressum-contact-email" },
      { t: "link", label: "Contact Page:", x: "https://www.burmesehub.com/contact", href: "/contact", testid: "impressum-contact-page" },
      { t: "motto", x: "BurmeseHub.com — Connecting Businesses. Strengthening Communities." },
    ],
  },
];

export default SECTIONS;
